<template>
  <div>
    <v-container v-if="!headers">
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>

    <material-card v-show="headers" elevation="0">
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        :selectActions="selectActions"
        :tableActions="tableActions"
        fileNamePrefix="eligibility"
        :identifier="identifier"
        @itemsChanged="setData($event)"
        @error="error = $event"
      >
        <template v-slot:item.EligibleExpiryDate="{ item }">
          <v-simple-checkbox :value="isEligible(item)" disabled />
        </template>
      </pbas-data-table>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import getEligibilityReportsHeaders from "../headers/EligibilityReports";
export default {
  name: "eligibility-table",
  components: { ErrorHandler },
  props: [
    "url",
    "saving",
    "inArchive",
    "insuranceCarrier",
    "date",
    "identifier",
  ],
  data() {
    return {
      error: null,
      archiveTarget: null,
      provider: undefined,
      columnsOptions: {},
      displayFunctions: {},
      selectActions: [],
      tableActions: [],
      headers: [],
      items: [],
      selected: [],
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    tableTitle() {
      return "Eligibility";
    },
  },
  watch: {
    url: {
      handler(v) {
        if (v) this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
    ]),
    isEligible(item) {
      console.log(item, this.date);
      if (
        item.EligibleEffectiveDate === null ||
        item.EligibleEffectiveDate === undefined
      ) {
        console.log("false because EligibleEffectiveDate is null");
        return false;
      }
      const date = Date.parse(this.date);
      const eligibleEffectiveDate = Date.parse(item.EligibleEffectiveDate);
      console.log(date, eligibleEffectiveDate, date < eligibleEffectiveDate)
      if (date < eligibleEffectiveDate) {
        console.log("false because date < eligibleEffectiveDate");
        return false;
      }
      if (
        item.EligibleExpiryDate === null ||
        item.EligibleExpiryDate === undefined
      ) {
        console.log("true because date >= eligibleEffectiveDate and EligibleExpiryDate is null");
        return true;
      }
      const eligibleExpiryDate = Date.parse(item.EligibleExpiryDate);
      console.log(date, eligibleExpiryDate, date < eligibleExpiryDate);
      return date < eligibleExpiryDate;
    },
    async loadPlanData() {
      try {
        let headers = (await this.getMembersManagementColumns(
          this.selectedPlan.Id
        )).data.sort((a, b) => {
          return a.order - b.order;
        });

        this.headers = getEligibilityReportsHeaders(this.date).filter(
          (o) =>
            headers.filter((h) => h.value === o.type.key).length > 0 ||
            o.type.key === "EligibleExpiryDate" ||
            o.type.key === "EligibleEffectiveDate"
        );

        if (this.provider) {
          this.provider = new PbasOData(
            this.$axiosHttp,
            this.url,
            this.headers
          );
          this.$nextTick(() => {
            this.$refs.table.getDataAsync();
          });
        } else
          this.provider = new PbasOData(
            this.$axiosHttp,
            this.url,
            this.headers
          );
      } catch (error) {
        console.log("error");
        this.$emit("onerror", error);
        this.headers = [];
      }
    },

    setData(items) {
      this.items = items;
    },

    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
  },
};
</script>

<style></style>
